export default __webpack_public_path__ + "static/media/FlyingFrog26.423b6f9a.png";